/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

// and Menu.js

import * as React from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import Auth from "../shared/Auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { NavLink, Link } from "react-router-dom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";
import './_Sidebar.css';
import GestureDetect from "./GestureDetect";
import Icon from "./Icon";
import AlertIcon from "./AlertIcon";
import ChatIcon from "./chat/ChatIcon";
import BaseCom from "./BaseCom";
import L from "./Lang";
import CartIcon from "./CartIcon";
import LangIcon from "./LangIcon";
import Alert from "./Alert";
import { SidebarGlobal } from "./_SidebarGlobal";

class NavItem extends React.Component {

    render() {
        return (<li className="nav-item">
            <NavLink to={this.props.href} className="nav-link d-flex align-items-center sidebar-nav-link" end={this.props.end}>
                {this.props.icon ? (<FontAwesomeIcon icon={this.props.icon} className="sidebar-nav-icon d-block" />) : ''}
                <div className="sidebar-nav-label"><L>{this.props.label}</L></div>
                {this.props.new ? <div className="badge sidebar-new-badge ms-auto"><L>NEW</L></div> : ''}
            </NavLink>
        </li>);

    }
}

class NavHeader extends React.Component {

    render() {
        return (<div className="nav-header"><L>{this.props.label}</L></div>);
    }
}

class NavGroup extends React.Component {
    render() {
        return (<ul className="nav nav-pills flex-column sidebar-nav-group">
            {this.props.children}
        </ul>);

    }
}



class Sidebar extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            toggle: window.innerWidth >= 768,
            subNav: null,
            search: {}
        }
        SidebarGlobal.setSubNav = this.setSubNav;
        SidebarGlobal.clearSubNav = this.clearSubNav;
        SidebarGlobal.toggle = this.toggle;
        SidebarGlobal.success = this._success;
        SidebarGlobal.warning = this._warning;
    }

    async componentDidMount() {
        this.props.onSidebarToggle(this.state.toggle);
        await this.getMainOrg();
        await this.getSettings();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            this.setState({ user: this.props.user });
    }

    returnToAdmin = () => {
        if (this.state.user.impersonatedByUser) {
            qreq.post('/api/user/impersonate/return', {}, j => {
                if (j.errorCode === 0)
                    document.location.replace('/');
            })
        }
    }

    setSubNav = (children) => {
        setTimeout(() => {
            this.setState({ subNav: children });
        }, 100);
    }

    clearSubNav = () => {
        this.setState({ subNav: null });
    }

    search = (e) => {
        if (e) e.preventDefault();
        if (this.state.search.query)
            this.props.navigate('/search/' + encodeURIComponent(this.state.search.query));
        else
            this.props.navigate('/');
    }

    toggle = (on) => {
        this.setState({ toggle: on });
        this.props.onSidebarToggle(on);
    }

    _success = (msg) => {
        this.setState({ successMessage: msg });
        setTimeout(() => {
            this.setState({ successMessage: null });
        }, 5000);
    }

    _warning = (msg) => {
        this.setState({ warningMessage: msg });
        setTimeout(() => {
            this.setState({ warningMessage: null });
        }, 5000);
    }

    render() {
        if (!this.state.publicSettings)
            return;

        return (<>
            <GestureDetect onSwipeLeft={() => this.toggle(true)} onSwipeRight={() => this.toggle(false)} />
            <nav className="c-nav navbar --bg-primary no-select">
                <div className="container-fluid d-flex justify-content-between align-items-center c-nav-content">
                    <div className="d-block mx-2">
                        <button onClick={() => this.toggle(!this.state.toggle)} className="navbar-toggler d-none d-md-block" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarToggle" aria-controls="sidebarToggle" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="icon-wrapper">
                            <img src={this.getLogo()} alt="" className={'d-block d-md-none icon bg-white rounded'} />
                        </div>
                    </div>
                    <div>
                        {this.state.successMessage && (
                            <div className="nav-alert-success alert alert-success d-flex align-items-center py-1 px-3 mb-0"
                                role="alert"
                                aria-live="polite">
                                <Icon icon="faCheckCircle" className="me-2" />
                                <div>{this.state.successMessage}</div>
                                <button
                                    type="button"
                                    className="btn-close ms-2"
                                    onClick={() => this.setState({ successMessage: null })}></button>
                            </div>
                        )}
                        {this.state.warningMessage && (
                            <div className="nav-alert-warning alert alert-warning d-flex align-items-center py-1 px-3 mb-0"
                                role="alert"
                                aria-live="polite">
                                <Icon icon="faExclamationCircle" className="me-2" />
                                <div>{this.state.warningMessage}</div>
                                <button
                                    type="button"
                                    className="btn-close ms-2"
                                    onClick={() => this.setState({ warningMessage: null })}></button>
                            </div>
                        )}
                    </div>
                    <div className="d-flex justify-content-end">
                        <div className="d-flex justify-content-end gap-1">
                            {this.state.subNav}
                        </div>
                        <CartIcon />
                        <ChatIcon />
                        <AlertIcon />
                        <Dropdown className="ms-2" style={{ zIndex: '9992' }}>
                            <Dropdown.Toggle className="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false" variant="secondary">
                                <strong><FontAwesomeIcon icon={fa.faUser} /> <span className="d-none d-md-inline">{this.state.user ? this.state.user.firstName + ' ' + this.state.user.lastName : ''}</span></strong>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu dropdown-menu-dark text-small shadow" aria-labelledby="dropdownUser1">
                                {this.state.user.impersonatedByUser ? <Dropdown.Item className="dropdown-item" onClick={e => { e.preventDefault(); this.returnToAdmin(); }}><L>Back to</L> {this.state.user.impersonatedByUser.firstName + ' ' + this.state.user.impersonatedByUser.lastName}</Dropdown.Item> : ''}
                                <Dropdown.Item role="button" className="dropdown-item" onClick={e => { e.preventDefault(); this.props.navigate('/my/info'); }}><L>My Profile</L></Dropdown.Item>
                                <Dropdown.Item role="button" className="dropdown-item" onClick={this.logout}><L>Logout</L></Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <LangIcon className="d-none d-md-block ms-2" />
                    </div>
                </div>
            </nav>
            <nav className={'c-sidebar d-md-flex flex-column flex-shrink-0 --bg-primary no-select ' + (this.state.toggle ? 'c-sidebar-open' : 'c-sidebar-close')}>
                <div className="sidebar-brand">
                    <Link to="/" className="sidebar-brand-link">
                        <img src={this.getLogo()} alt="" className={'sidebar-brand-logo d-block img-fluid rounded' + (this.state.user.organizationID ? ' bg-white p-2' : '')} />
                    </Link>
                </div>
                <div className="sidebar-scroll mb-auto">
                    {this.state.MODEL === 'MST' && <>
                        <NavHeader label="Orchestrator" />
                        <NavGroup>
                            {Auth.hasRole('admin') ? <NavItem href="/instance" label="Instances" icon={fa.faInstitution} /> : ''}
                        </NavGroup>
                    </>}
                    {this.state.MODEL !== 'MST' && <>
                        {(Auth.hasRole('manager') || Auth.hasRole('account-manager') || this.state.MODEL === 'WMS') && <>
                            <NavHeader label="Main" />
                            <NavGroup>
                                {Auth.hasRole('manager') || Auth.hasRole('account-manager') ? <NavItem href="/dashboard" label="Dashboard" icon={fa.faGaugeSimpleHigh} /> : ''}
                                {this.state.MODEL === 'WMS' && <NavItem href="/calendar" label="Calendar" icon={fa.faCalendar} />}
                                {this.state.MODEL === 'WMS' && <NavItem href="/myday" label="My Day" icon={fa.faSun} />}
                            </NavGroup>
                        </>}
                        {this.state.MODEL === 'WMS' && (Auth.hasRole('account-manager') || Auth.hasRole('field') || Auth.hasRole('admin')) && <>
                            <NavHeader label={this.T('subject') + 's'} />
                            <NavGroup>
                                {Auth.hasRole('manager') || Auth.hasRole('account-manager') ? <NavItem href="/lead" label="Queue" icon={fa.faNetworkWired} /> : ''}
                                {Auth.hasRole('account-manager') || Auth.hasRole('provider') || Auth.hasRole('nurse') ? <NavItem href="/order" label={this.T('subject') + 's'} icon={fa.faBox} /> : ''}
                                {Auth.hasRole('manager') ? <NavItem href="/document/analyze/upload" label="Document Analyzer" icon={fa.faUpload} /> : ''}
                            </NavGroup></>}
                        {this.state.MODEL === 'LIS' && <>
                            <NavHeader label="Lab" />
                            <NavGroup>
                                <NavItem href="/specimen/list" label={this.T('specimen') + 's'} icon={fa.faVial} />
                                {Auth.hasRole('manager') && <NavItem href="/results/review" label="Results" icon={fa.faVialCircleCheck} />}
                                {Auth.hasRole('admin') && <NavItem href="/lab/manager" label="Lab Management" icon={fa.faGears} />}
                            </NavGroup>
                        </>}

                        {this.state.MODEL === 'GEN' && <>
                            <NavHeader label="Work" />
                            <NavGroup>
                                {Auth.hasRole('manager') && <NavItem href="/project" label="Projects" icon={fa.faBolt} />}
                                <NavItem href="/workorder" label="Work Order" icon={fa.faBriefcase} />
                            </NavGroup>
                        </>}

                        {this.state.MODEL === 'MNF' && Auth.hasRole('consumer') && <>
                            <NavHeader label="Shop" />
                            <NavGroup>
                                <NavItem href="/shop/category" label="Place Order" icon={fa.faShop} />
                            </NavGroup>
                        </>}
                        {this.state.MODEL === 'MNF' && <>
                            {Auth.hasRole('manager') && <>
                                <NavHeader label="Manufacturing" />
                                <NavGroup>
                                    <NavItem href="/inventory" label="Inventory" icon={fa.faWarehouse} end />
                                    <NavItem href="/inventory/instock" label="In Stock" icon={fa.faCubes} />
                                    <NavItem href="/product/list" label="Products" icon={fa.faBox} />
                                    <NavItem href="/scan/in" label="Scan In" icon={fa.faPlaneArrival} />
                                    <NavItem href="/scan/out" label="Scan Out" icon={fa.faPlane} />
                                </NavGroup>
                                {/*
                                <NavHeader label="Mapping" />
                                <NavGroup>
                                    <NavItem href="/inventory/box" label="Boxes" icon={fa.faBoxes} />
                                </NavGroup>
                                */}
                            </>}
                            {(Auth.hasRole('distribution-recipient') || Auth.hasRole('sub-distributor')
                                || Auth.hasRole('distributor') || Auth.hasRole('billing-distributor')) && <>
                                    <NavHeader label="Distribution" />
                                    <NavGroup>
                                        {!Auth.hasRole('manager') && <NavItem href="/inventory" label="Inventory" icon={fa.faWarehouse} />}
                                        {!Auth.hasRole('consumer') && <NavItem href="/purchase-order" label="Purchase Orders" icon={fa.faBoxes} />}
                                        {Auth.hasRole('consumer') && <NavItem href="/purchase-order" label="Orders" icon={fa.faBoxes} />}
                                        {!Auth.hasRole('manager') && <NavItem href="/scan/in" label="Scan In" icon={fa.faPlaneArrival} />}
                                        {!Auth.hasRole('manager') && <NavItem href="/scan/out" label="Scan Out" icon={fa.faPlane} />}
                                    </NavGroup>
                                </>}
                        </>}

                        {/* DISTRIBUTOR ONLY MENU */}
                        {Auth.hasRole('distributor') && !Auth.hasRole('manager') && <>
                            <NavHeader label="Management" />
                            <NavGroup>
                                <NavItem href="/account" label="Accounts" icon={fa.faHouse} />
                                {Auth.hasRole('billing-distributor') && <NavItem href="/invoice" label="Invoices" icon={fa.faFileInvoice} />}
                            </NavGroup>
                        </>}

                        {this.state.MODEL !== 'GEN' && this.state.MODEL !== 'MNF' && Auth.hasRole('billing') && <>
                            <NavHeader label="Billing" />
                            <NavGroup>
                                <NavItem href="/claim/list" label="Claims" icon={fa.faFileInvoiceDollar} />
                            </NavGroup>
                        </>}

                        {Auth.hasRole('admin') ? <>
                            <NavHeader label="Management" />
                            <NavGroup>
                                {Auth.hasRole('account-manager') && <NavItem href="/account" label="Accounts" icon={fa.faHouse} />}
                                {Auth.hasRole('admin') ? <NavItem href="/invoice" label="Invoices" icon={fa.faFileInvoice} /> : ''}
                                {this.state.MODEL === 'GEN' && Auth.hasRole('admin') ? <NavItem href="/quote" label="Quotes" icon={fa.faDiagramPredecessor} /> : ''}
                                {Auth.hasRole('admin') ? <NavItem href="/payment-transaction" label="Payment Transactions" icon={fa.faCashRegister} /> : ''}
                                {this.state.MODEL === 'WMS' && Auth.hasRole('admin') ? <NavItem href="/reports" label="Reports" icon={fa.faFileExcel} /> : ''}
                            </NavGroup></> : ''}

                    </>}

                    {(Auth.hasRole('account-manager') || Auth.hasRole('sales') || Auth.hasRole('admin')) && <>
                        <NavHeader label="Admin" />
                        <NavGroup>
                            <NavItem href="/manager" label={'Administration'} icon={fa.faScrewdriverWrench} />
                        </NavGroup>
                    </>}

                </div>
            </nav>
            <nav className="c-nav-mobile d-flex d-md-none align-items-center justify-content-evenly  no-select">
                {(Auth.hasRole('manager') || Auth.hasRole('account-manager')) && <NavLink to="/dashboard" className="c-nav-mobile-item">
                    <Icon icon="faGaugeSimpleHigh" />
                    <span><L>Dashboard</L></span>
                </NavLink>}
                {this.state.MODEL === 'LIS' && <NavLink to="/specimen/list" className="c-nav-mobile-item">
                    <Icon icon="faVial" />
                    <span>{this.T('specimen') + 's'}</span>
                </NavLink>}
                {this.state.MODEL === 'LIS' && Auth.hasRole('manager') && <NavLink to="/results/review" className="c-nav-mobile-item">
                    <Icon icon="faVialCircleCheck" />
                    <span><L>Results</L></span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && (Auth.hasRole('practitioner') || Auth.hasRole('nurse')) && <NavLink to="/myday" className="c-nav-mobile-item">
                    <Icon icon="faSun" />
                    <span><L>My Day</L></span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && <NavLink to="/calendar" className="c-nav-mobile-item">
                    <Icon icon="faCalendar" />
                    <span><L>Calendar</L></span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && (Auth.hasRole('account-manager') || Auth.hasRole('provider') || Auth.hasRole('nurse')) && <NavLink to="/order" className="c-nav-mobile-item">
                    <Icon icon="faBox" />
                    <span><L>Patients</L></span>
                </NavLink>}
                {this.state.MODEL === 'WMS' && (Auth.hasRole('manager') || Auth.hasRole('account-manager')) && <NavLink to="/lead" className="c-nav-mobile-item">
                    <Icon icon="faNetworkWired" />
                    <span><L>Queue</L></span>
                </NavLink>}
                {this.state.MODEL === 'MNF' && Auth.hasPolicy('consumer') && <NavLink to="/shop/category" className="c-nav-mobile-item">
                    <Icon icon="faShop" />
                    <span><L>Place Order</L></span>
                </NavLink>}
                {this.state.MODEL === 'MNF' && <NavLink to="/inventory" className="c-nav-mobile-item">
                    <Icon icon="faWarehouse" />
                    <span><L>Inventory</L></span>
                </NavLink>}
                {this.state.MODEL === 'MNF' && <NavLink to="/purchase-order" className="c-nav-mobile-item">
                    <Icon icon="faBoxes" />
                    <span><L>POs</L></span>
                </NavLink>}
                {this.state.MODEL === 'MNF' && Auth.hasRole('manager') && <NavLink to="/product/list" className="c-nav-mobile-item">
                    <Icon icon="faBox" />
                    <span><L>Products</L></span>
                </NavLink>}
                <NavLink to="/menu" className="c-nav-mobile-item">
                    <Icon icon="faBars" />
                    <span><L>Menu</L></span>
                </NavLink>
            </nav>
        </>);
    }
}

export default withParamsAndNavigate(Sidebar);